module.exports = __webpack_public_path__ + "static/media/3-dots-white.5f36920b.svg";